import { pipe, map, keysIn, prop, pick, find, propEq, defaultTo, converge, curryN, flip, } from 'ramda';
export var validate = function (rulesFn, props) {
    return pipe(
    // Test rules and filter out results of fields whose values were not supplied
    converge(pick, [keysIn, flip(curryN(2, rulesFn))(props)]), 
    // Map value to first Rule that evaluated to true
    map(find(propEq('condition', true))), 
    // Map value to message prop of Rule ('' default)
    map(pipe(prop('message'), defaultTo(''))));
};
//# sourceMappingURL=validate.js.map